import React from "react";
import { AppBar, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { ServerClock } from "./ServerClock";

export const HeaderContentBar = ({ title = "", isAdmin = false, setIsAdmin = undefined, isHideHeader = false }) => {
  const style = {
    areaHeader: {
      display: "flex",
      justifyContent: "space-between",
      height: 35,
      boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
    },
    bgUserNameBar: {
      backgroundColor: "#e2dfdf",
      border: "1px solid #e2dfdf",
    },
    bgTitleBar: {
      backgroundColor: "#969191",
      border: "1px solid #969191",
      color: "#ffff",
    },
    shadowNone: {
      boxShadow: "none",
    },
    appBar: {
      marginBottom: 15,
    },
  };

  const styleAppBar = {
    ...style.shadowNone,
    ...style.appBar,
  };

  const styleUserBar = {
    ...style.areaHeader,
    ...style.bgUserNameBar,
  };

  const styleTitleBar = {
    ...style.areaHeader,
    ...style.bgTitleBar,
  };

  const handleRole = () => {
    if (setIsAdmin) setIsAdmin(!isAdmin);
  };

  const user = useSelector(state => state.auth.user);
  const USER = `User: ${user?.displayName ?? "Dummy User"}`;
  const ADMIN = `Admin: ${user?.displayName ?? "Dummy Admin"}`;
  return (
    <AppBar position="static" color="secondary" style={styleAppBar} enableColorOnDark>
      <div style={styleUserBar}>
        {!isHideHeader ? (
          <>
            <div id="hdlb" style={{ color: "red", fontWeight: "bold", margin: "auto 15px" }}>
              POLYGON
            </div>
            <Typography
              component="button"
              onClick={handleRole}
              sx={{ border: "none", backgroundColor: "#e2dfdf", margin: "auto 15px" }}
              tabIndex={-1}>
              {isAdmin ? ADMIN : USER}
            </Typography>
          </>
        ) : null}
      </div>
      <div style={styleTitleBar}>
        <div style={{ margin: "auto 15px" }}>{title}</div>
        <ServerClock />
      </div>
    </AppBar>
  );
};
